import React, { useState } from 'react';
import Scheduling from './Scheduling';



const Regenerate = () => {
  const [viewMode, setViewMode] = useState('queue'); // 'queue', 'calendar', or 'guided'
  const [workoutProgram, setWorkoutProgram] = useState([
    { day: 'Day 1', exercises: [{ name: 'squat', sets: 3, reps: 8, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }, { name: 'benchPress', sets: 4, reps: 6, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }] },
    { day: 'Day 2', exercises: [{ name: 'pullUp', sets: 3, reps: 10, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }, { name: 'deadlift', sets: 3, reps: 5, weight: { value: 100, unit: 'kg' }, tempo: [2, 0, 1, 0], expanded: false }] },
  ]);

  const [workoutPreferences, setWorkoutPreferences] = useState({ duration: '', frequency: '' });

  return (
    <div className="card" style={{backgroundColor: 'rgba(0,0,0,0.4)',
      color: 'white'
    }}>

   <div className="card workout-preferences">
   <h1>Scheduling</h1>
      <p>Specify the client's workout preferences.</p>
        <label htmlFor="duration">How long should each session be?</label>
        <input
          id="duration"
          type="text"
          value={workoutPreferences.duration}
          onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, duration: e.target.value })}
          placeholder="Duration in minutes (e.g., 60 for 60 minutes)"
        />
        <label htmlFor="frequency">How many times per week should sessions be?</label>
        <input
          id="frequency"
          type="number"
          value={workoutPreferences.frequency}
          onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, frequency: e.target.value })}
          placeholder="Times per week"
        />
        <label htmlFor="duration">How many sessions should be generated?</label>

        {/* In weeks or in number of sessions both available  */}
        <input
          id="sessions"
          type="number"
          value={workoutPreferences.sessions || ''}
          onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, sessions: e.target.value })}
          placeholder="Number of sessions"
        />

        {/* Now in weeks  */}
        <label htmlFor="weeks">Or, how many weeks should the plan cover?</label>
        <input 
            id="weeks"
            type="number"
            value={workoutPreferences.weeks || ''}
            onChange={(e) => setWorkoutPreferences({ ...workoutPreferences, weeks: e.target.value })}
            placeholder="Weeks"
        />


      <h1>Generate New Sessions</h1>
      <div>
        Any existing sessions and plans you may have made will be wiped out.

        Past workouts will remain intact, but all future sessions will be replaced with a new program.
        <div style={{margin: '1rem'}}>
            <span
            className="copy-link"
            onClick={() => alert('Not implemented yet!')}
            >
            Generate More Sessions!
            </span>
        </div>
      </div>

      </div>
    </div>
  );
};

export default Regenerate;